var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"root",staticClass:"tree-weather-root",class:'ntds-sky-gradient--'+_vm.momentOfDay},[_c('img',{attrs:{"src":_vm.treeImage}})])}
var staticRenderFns = []

export { render, staticRenderFns }